import { render, staticRenderFns } from "./LoginPhoneView.vue?vue&type=template&id=4633c720&"
import script from "./LoginPhoneView.vue?vue&type=script&lang=js&"
export * from "./LoginPhoneView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports